import React from 'react';
import {
	GET_LAWYER_DIRECTORY_ACTION_FILTER,
	lawyerDirectoryService,
} from '@/api';
import { HeaderFilterTable } from '@/components/common';
import { Options } from '@/components/ui/combobox';
import { useFilters } from '@/hooks';
import { useQuery } from '@tanstack/react-query';
import { ClientDirectoryFiltersType } from '@/interfaces';
import { FiltersInboxAdapter } from '@/adapters/filters-lawyer.adapter';

interface Props {
	title: string;
	filterKey: ClientDirectoryFiltersType;
	totalFilterKey: ClientDirectoryFiltersType;
	role: 'lawyer' | 'client';
}

export const TasksFilter: React.FC<Props> = ({
	title,
	role,
	filterKey,
	totalFilterKey,
}) => {
	const { setParamSeveralFilters, hasFilter } = useFilters();
	const [data, setData] = React.useState<Options[]>([]);

	const { lawyerTaskFilterAdapter, clientTaskFilterAdapter } =
		FiltersInboxAdapter;

	const { data: actionFilterList } = useQuery({
		queryKey: [GET_LAWYER_DIRECTORY_ACTION_FILTER],
		queryFn: () => lawyerDirectoryService.getActionFilters(),
	});

	React.useEffect(() => {
		if (actionFilterList) {
			const list =
				role === 'lawyer'
					? lawyerTaskFilterAdapter(actionFilterList.data)
					: clientTaskFilterAdapter();
			setData(list);
		}
	}, [actionFilterList]);

	const handleSelectFilters = (value?: string) => {
		// specials filters
		switch (value) {
			case '0':
			case '1':
			case '2':
				if (value === '0' || value === '1' || value === '2') {
					setParamSeveralFilters([
						{ label: filterKey, value: '' },
						{ label: totalFilterKey, value: value },
					]);
				}
				break;

			default:
				setParamSeveralFilters([
					{ label: filterKey, value: value },
					{ label: totalFilterKey, value: '' },
				]);
				break;
		}
	};

	const handleClearAll = () => {
		setParamSeveralFilters([
			{ label: filterKey, value: '' },
			{ label: totalFilterKey, value: '' },
		]);
	};

	return (
		<HeaderFilterTable
			title={title}
			searchTitle="Tasks"
			filterOptions={data}
			handleClearAll={handleClearAll}
			handleSelectFilters={handleSelectFilters}
			hasFilter={hasFilter(filterKey) || hasFilter(totalFilterKey)}
			classNamePopoverContent="lg:w-[262px]"
		/>
	);
};
